import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';
import { IterationStatusCode, LineOfBusiness, VettingIteration } from '#services/cve/VettingIteration';

export const tradeSectorMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId$',
    },
    response: {
      status: 200,
      body: {
        iterationId: 'iterationId',
        lineOfBusiness: LineOfBusiness.TCI,
        companyId: '113',
        statusCode: IterationStatusCode.CREATED,
        creation: {
          creationDateTime: '2024-04-19T10:05:42.156Z',
          creatorId: 'CVE',
          ownerId: 'CVE',
        },
        controls: [
          {
            controlCode: 'CompanyGrade',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'TradeSector',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'SensitiveBusiness',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'SensitiveCountry',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'EnergyPolicy',
            statusCode: ControllerStatus.NOT_STARTED,
          },
        ] satisfies ControllerDetails[],
        customProperties: {},
      } satisfies VettingIteration,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/CompanyGrade$',
    },
    response: {
      status: 200,
      body: {
        statusCode: ControllerStatus.ACKNOWLEDGED_WITH_CHECK_SUCCESS,
        controlCode: 'CompanyGrade',
        check: {
          requestDateTime: '2023-05-18T13:29:56.409Z',
          responseDateTime: '2023-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2025-09-26T00:00:00.000Z',
          controlData: {},
        },
        validation: {
          requestorId: 'CVE',
          validationDateTime: '2023-09-26T00:00:00.000Z',
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/TradeSector$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'TradeSector',
        statusCode: ControllerStatus.ACKNOWLEDGED_WITH_ESCALATION_ACCEPTED,
        check: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {
            tradeSectors: [
              { code: '4265', isMain: false },
              { code: '1234', isMain: true },
              { code: '9856', isMain: false },
            ],
          },
        },
        escalation: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-22T13:29:56.409Z',
          responseDateTime: '2024-05-23T13:29:56.409Z',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {
            tradeSectors: [
              { code: '4265', isMain: false },
              { code: '1234', isMain: true },
              { code: '9856', isMain: false },
            ],
            escalationResponse: {
              comment: '',
              validator: 'johndoe@gmail.fr',
            },
          },
        },
        validation: {
          requestorId: 'CVE',
          validationDateTime: '2024-05-20T13:29:56.409Z',
        },
      },
    },
  },
];
